// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3d6fw","header":"ClearentDisclaimer_header__2tAGy","inner":"ClearentDisclaimer_inner__1kRJz"};